<template>
  <!-- 投稿模块树状选择器 -->
  <ul class="ul_tree_select">
    <li class="li_item" v-for="item in treeList" :key="item.id">
      <div class="div_set flex_center cp_us" v-if="item.type == 'f0'">
        <i
          class="key_icon admin_out"
          :class="item.isOpened ? 'i_open' : ''"
          @click="clickItem(item)"
          >&#xe75a;</i
        >
      </div>
      <div
        class="div_file flex_between cp_us"
        :class="
          props.nowSelect.id == item.id
            ? props.nowSelect.type == item.type
              ? 'div_file_active'
              : ''
            : ''
        "
        @click="clickItem(item)"
      >
        <div class="div_file_left">
          <img :src="fileImgList[item.type].img" alt="" />
          <span>{{ item.title }}</span>
        </div>
        <span class="sp_number" v-if="item.number">{{ item.number }}</span>
      </div>
      <n-collapse-transition :show="item.children && item.isOpened">
        <FilesTreeSelect
          v-if="item.children && item.isOpened"
          :nowSelect="props.nowSelect"
          :list="item.children"
          @change="changeNowSelect"
        ></FilesTreeSelect>
      </n-collapse-transition>
    </li>
  </ul>
</template>

<script setup>
import { nextTick, ref, watch } from "vue";

import { findMindMapContent } from "@/api/user.js";
import { fileImgList } from "@/util/index.js";

const props = defineProps(["nowSelect", "list"]);
const emit = defineEmits(["change"]);

let treeList = ref([]);

watch(
  () => props.list,
  (newVal) => {
    treeList.value = newVal;
  },
  { deep: true }
);

treeList.value = props.list;

//查询下一级内容
function findeNextFiles(val, callback) {
  findMindMapContent({ pfid: val.id }).then((res) => {
    callback(setList(res.data));
  });
}

// 处理数据
let needType = ["f0", "c0", "c2", "c6", "c12", "c5", "c7", "c8", "c9"];
function setList(list) {
  let newList = [];
  list.forEach((val) => {
    let obj = {
      id: val.id,
      title: val.title,
      type: val.fileType,
      number: val.number || null,
    };
    if (obj.type == "f0") {
      obj.children = [];
      obj.isOpened = false; //是否展开
      obj.isFirstLoad = true; //是否第一次加载
    }
    // 暂时仅仅保留卡盒与文件夹
    if (needType.includes(obj.type)) {
      newList.push(obj);
    }
  });
  return newList;
}
// 点击事件
function clickItem(item) {
  switch (item.type) {
    case "f0":
      // 初次加载
      if (item.isFirstLoad) {
        item.isFirstLoad = false;
        item.isOpened = true;
        item.children = findeNextFiles(item, (list) => {
          item.children = list;
        });
      } else {
        item.isOpened = !item.isOpened;
      }
      break;
    default:
      changeNowSelect(item);
      break;
  }
}
function changeNowSelect(item) {
  emit("change", item);
}
</script>

<style lang='scss' scoped>
.ul_tree_select {
  padding-left: 10px;
  .li_item {
    width: 100%;
    position: relative;
    .div_set {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 16px;
      > i {
        font-size: 12px;
        color: #000000;
        display: inline-block;
      }
      .i_open {
        transform: rotate(90deg);
      }
    }
    .div_file {
      height: 50px;
      margin-left: 18px;
      padding: 0px 12px;
      border-radius: 12px;
      background-color: white;
      .div_file_left {
        flex: 1;
        > img {
          width: 32px;
          height: 32px;
          margin-right: 8px;
          vertical-align: middle;
        }
        > span {
          font-size: 16px;
          vertical-align: middle;
          color: #000000;
        }
      }

      .sp_number {
        font-size: 14px;
      }
      &:hover {
        background-color: #f8f8f8;
      }
    }
    .div_file_active {
      background-color: #f8f8f8;
    }
  }
}
</style>